/* Imports */
import React from "react"
import { Font, Button } from "fajny-react"
import { useParams } from "react-router-dom"
import { unslugify } from "js-utils-julseb"

import PageLayout from "../../components/PageLayout"
import NotFound from "../NotFound"
import ContainerIcon from "../../components/ContainerIcon"

import allIcons from "../../data/all-icons"

const IconDetailPage = () => {
    const { iconName } = useParams()

    const icon = allIcons.filter(icon => icon.name === iconName)[0]
    const allIconNames = allIcons.map(icon => icon.name)

    return !allIconNames.includes(iconName) ? (
        <NotFound icon />
    ) : (
        <PageLayout title={iconName}>
            <Button
                to="/icons"
                buttonStyle="text"
                fajnyIconLeft="arrow-left-solid"
                noPadding
            >
                Back to the list
            </Button>

            <Font.H1>{icon.name}</Font.H1>

            <Font.H3>{unslugify(icon.category)}</Font.H3>

            <ContainerIcon icon={icon} />
        </PageLayout>
    )
}

export default IconDetailPage
